import { render } from "./IconFilters.vue?vue&type=template&id=48143db0"
import script from "./IconFilters.vue?vue&type=script&lang=js"
export * from "./IconFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__